<template>
  <div>
    <!-- edit inside events modal -->
    <!-- <modal
      name="edit-inside-event-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-event
        title="odmor/doručak"
        :selectedDailyLog="selectedDailyLog"
        eventsType="inside"
        :employeeName="selectedNameValue"
    /></modal> -->

    <!-- edit outside events modal -->
    <!-- <modal
      name="edit-outside-event-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-event
        title="Izlasci"
        :selectedDailyLog="selectedDailyLog"
        eventsType="outside"
        :employeeName="selectedNameValue"
    /></modal> -->

    <!-- print area -->
    <div class="base-demo-print-area">
      <!-- title -->
      <div class="ex1">
        <h2 class="subtitle">
          {{ department.name }}
        </h2>
      </div>

      <!-- date -->
      <div class="has-text-left is-size-10">
        <p>
          mjesec:
          <span>
            {{ monthName }}
          </span>
        </p>
      </div>

      <!-- Table -->
      <div class="base-demo">
        <vue-table-dynamic
          :params="params"
          @cell-click="tableCellClicked"
          @on-row-dblclick="onRowDoubleClick"
          @row-click="onRowClicked"
          @cell-contextmenu="cm"
        >
          <template v-slot:column-1="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
              }"
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-2="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-3="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-4="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-5="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-6="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-7="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-8="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-9="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-10="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-11="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-12="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-13="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-14="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-15="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-16="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-17="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-18="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-19="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-20="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-21="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-22="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-23="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-24="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-25="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-26="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-27="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-28="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-29="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-30="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-31="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-32="{ props }">
            <span
              class="cell--slot-1"
              :style="{
                color: props.cellData.color,
                background: props.cellData.backgroundColor,
                position: 'relative',
              }"
              :title="props.cellData.title"
              ><span
                v-if="props.cellData.borderLeftColor"
                class="cell-inconsistency-triangle"
                :style="{
                  borderTopColor: props.cellData.borderLeftColor,
                }"
              ></span
              >{{ props.cellData.value }}</span
            >
          </template>
          <!-- <template v-slot:column-3="{ props }">
            <span class="cell--slot">
              <button
                class="aside-btns aside-btns-slot"
                size="mini"
                @click.stop="testSlot(props)"
              >
                T1
              </button>
            </span>
          </template> -->
        </vue-table-dynamic>
      </div>

      <!-- contex menu -->
      <context-menu :display="showContextMenu" ref="menu">
        <ul>
          <!-- <li @click="cmEditClicked">
            <p class="cmitem">Uredi</p>
          </li> -->
          <li @click="cmCommentClicked" v-show="isCommentCMVisible">
            <p class="cmitem">Komentar</p>
          </li>
          <li @click="cmLateClicked" v-show="isLateCMVisible">
            <p style="background-color: yellow" class="cmitem">
              Status kašnjenja
            </p>
          </li>
          <li @click="cmViewDetails" v-show="isCommentCMVisible">
            <p style="background-color: lightGreen" class="cmitem">
              Vidi detalje...
            </p>
          </li>
        </ul>
      </context-menu>
      <!-- <button @click="openContextMenu">activate context menu</button> -->

      <!-- spinner -->
      <div class="columns is-mobile" v-show="isLoading">
        <div class="column is-1 is-offset-half">
          <div class="container">
            <div class="has-text-centered">
              <p>loading...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueTableDynamic from "vue-table-dynamic";
// import ReportService from "../../services/report.service";
import ContextMenu from "../parts/ContextMenu.vue";
import ReportService from "../../services/report.service";

import {
  // getDepartmentFromEmployeeId,
  // getDateFromTicks,
  // getSecondsFromTicks,
  // getStartedYesterdayStayString,
  // getStayedTillTomorrowString,
  // getDailyLogsFromDepartmentId,
  // getBusinessEventString,
  // getRestEventString,
  // getPrivateEventString,
  getStatusCodeFromStatusId,
  // getShortTimeFromTicks,
  getMonthNameFromId,
  getFirstDateOfMonth,
  getLastDateOfMonth,
  addDays, // getStatusCodeFromStatusId,
  shouldEmployeeBeAdded,
} from "../../_helpers/arrangers";

const colors = [
  "#363636",
  "#046FDB",
  "#F85252",
  "#8B54E4",
  "#F07B3B",
  "#3ba272",
  "#ecfeff",
  "#fc3d03",
  "#faa614",
];

// const MEDIUM_LATE = 600;
// const EXTREME_LATE = 1800;

export default {
  name: "AbsenceListTable",

  components: {
    VueTableDynamic,
    ContextMenu,
  },

  props: {
    department: Object,
    selectedMonth: Number,
    selectedYear: Number,
    // startDate: Date,
    // endDate: Date,
    statuses: Array,
    departmentData: Array,
    inputDailyLogs: Array,
    filterLateValue: Number,
    absenceStatuses: Array,
  },

  data() {
    return {
      //   monthChosen
      time3: null,
      employees: [],
      dailyLogs: [],
      isLoading: false,
      showContextMenu: false,
      isCommentCMVisible: true,
      isLateCMVisible: false,
      startDate: Date,
      endDate: Date,
      firstDay: Date,
      lastDay: Date,
      params: {
        data: [
          [
            "Ndx",
            "Ime i prezime",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "30",
            "31",
            "Σ GO",
          ],
        ],
        header: "row",
        enableSearch: false,
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: "3%" },
          { column: 2, width: 40 },
          { column: 3, width: 40 },
          { column: 4, width: 40 },
          { column: 5, width: 40 },
          { column: 6, width: 40 },
          { column: 7, width: 40 },
          { column: 8, width: 40 },
          { column: 9, width: 40 },
          { column: 10, width: 40 },
          { column: 11, width: 40 },
          { column: 12, width: 40 },
          { column: 13, width: 40 },
          { column: 14, width: 40 },
          { column: 15, width: 40 },
          { column: 16, width: 40 },
          { column: 17, width: 40 },
          { column: 18, width: 40 },
          { column: 19, width: 40 },
          { column: 20, width: 40 },
          { column: 21, width: 40 },
          { column: 22, width: 40 },
          { column: 23, width: 40 },
          { column: 24, width: 40 },
          { column: 25, width: 40 },
          { column: 26, width: 40 },
          { column: 27, width: 40 },
          { column: 28, width: 40 },
          { column: 29, width: 40 },
          { column: 30, width: 40 },
          { column: 31, width: 40 },
          { column: 32, width: 40 },
          { column: 33, width: 40 },
        ],
        highlight: { column: [-1] },
        highlightedColor: colors[4],
      },
      //   departments: [],
      //   seletedDepartment: null,
    };
  },

  mounted() {
    // // this.arrangeData(undefined, this.department.id);
    // // this.arrangeDataSimple(this.department.id);
    // this.arrangeData();
    // console.log("moj sektor:");
    // console.log(this.department);

    let departmentId = this.department.id;

    // this.departmentData = this.$store.state.general.departmentData;

    let allEmployees = this.departmentData.find((d) => {
      return d.departmentId === departmentId;
    }).employee;

    this.employees = [];
    allEmployees.forEach((emp) => {
      if (shouldEmployeeBeAdded(emp, this.selectedMonth, this.selectedYear)) {
        this.employees.push(emp);
      }
    });
    console.log("this.employees");
    console.log(this.employees);

    // calculate date for first day this month
    this.firstDay = getFirstDateOfMonth(this.selectedMonth, this.selectedYear);
    this.lastDay = getLastDateOfMonth(this.selectedMonth, this.selectedYear);

    console.log("first day");
    console.log(this.firstDay);
    console.log("last day");
    console.log(this.lastDay);

    this.getData(this.department.id, this.selectedMonth, this.selectedYear);
  },

  computed: {
    monthName() {
      return getMonthNameFromId(this.selectedMonth);
    },
  },

  watch: {
    absenceStatuses(newVal, oldVal) {
      // When absenceStatuses are loaded (from empty to populated), apply them to existing data
      if (
        newVal &&
        newVal.length > 0 &&
        (!oldVal || oldVal.length === 0) &&
        this.employees.length > 0
      ) {
        console.log("absenceStatuses loaded, applying to table");
        this.calculateData(this.dailyLogs || []);
        // Apply absence statuses
        this.applyAbsenceStatuses();
        // Reset and push data to table
        this.resetUi();
        this.pushData();
      }
    },
  },

  methods: {
    openContextMenu(e) {
      this.$refs.menu.open(e);
    },
    cmEditClicked() {
      // console.log("jedan");
      this.$refs.menu.close();
    },
    cmViewDetails() {
      console.log("hic!");
      console.log(this.selectedEmplyoee);
      console.log(this.selectedDailyLog);
      console.log(this.selectedEmplyoee.firstName);
      const theDate = new Date(
        this.startDate.getTime() - this.startDate.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];

      this.$router.push(
        "/user/ManualFix?date=" +
          theDate +
          "&employeeId=" +
          this.selectedEmplyoee.employeeId
      );
    },
    cmCommentClicked() {
      console.log("hic!");
      console.log(this.selectedEmplyoee);
      console.log(this.selectedDailyLog);

      this.$emit("editCommentClicked", {
        id: this.department.id,
        emp: this.selectedEmplyoee,
        dl: this.selectedDailyLog,
        dt: this.startDate,
      });
      this.$refs.menu.close();
    },
    recalcEmployee() {
      // console.log("xxx");
      // console.log(this.departmentId);
      // this.employees.push({
      //   name: "jedan", // emp.firstName + " " + emp.lastName,
      //   id: 1, //emp.employeeId,
      // });
      return ReportService.GetNormalizedAccessDataByTimeRange(
        this.startDate,
        this.endDate,
        this.selectedEmplyoee.employeeId,
        this.departmentId
      );
    },
    cmLateClicked() {
      this.$emit("editLateJustifiedClicked", {
        emp: this.selectedEmplyoee,
        dl: this.selectedDailyLog,
      });
      // });
    },
    refresh() {
      this.resetUi();
      this.getData(this.department.id, this.selectedMonth, this.selectedYear);
    },
    resetUi() {
      console.log("provala");
      this.params.data = [
        [
          "Ndx",
          "Ime i prezime",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31",
          "Σ GO",
        ],
      ];
    },
    tableCellClicked(row, column) {
      if (column == 1) {
        // selected employee
        this.selectedEmplyoee = this.employees.find(
          (x) => x.correspondingRowId === row
        );
      }
      // Emit event for GO mode click with employee and date info
      if (column >= 2 && column <= 32) {
        let day = this.params.data[0][column];
        let employee = this.employees.find((x) => x.correspondingRowId === row);
        if (employee && day) {
          let datum =
            this.selectedYear +
            "-" +
            String(this.selectedMonth).padStart(2, "0") +
            "-" +
            String(day).padStart(2, "0");
          let clickDate = new Date(datum);
          clickDate.setHours(0, 0, 0, 0);
          this.$emit("goModeClick", {
            id: this.department.id,
            emp: employee,
            dt: clickDate,
          });
        }
      }
    },
    onRowDoubleClick(params) {
      console.log(params);
    },
    onRowClicked() {},
    cm(params, row, column) {
      this.selectedEmplyoee = this.employees.find(
        (x) => x.correspondingRowId === row
      );
      console.log("row; column;");
      console.log(row);
      console.log(column);
      console.log(this.params.data[0][column]);
      let day = this.params.data[0][column];
      console.log("employees");
      console.log(this.employees);
      console.log("selectedEmployee");
      console.log(this.selectedEmplyoee);
      console.log("selectedDailyLog");

      let datum =
        this.selectedYear +
        "-" +
        String(this.selectedMonth).padStart(2, "0") +
        "-" +
        String(day).padStart(2, "0");

      let datumfull = datum + "T00:00:00";
      console.log("datum");
      console.log(String(this.selectedMonth).padStart(2, "0"));
      console.log(datum);

      this.startDate = new Date(datum);
      this.startDate.setHours(0, 0, 0, 0);
      this.endDate = addDays(this.startDate, 1);

      console.log("start date");
      console.log(this.startDate);

      console.log("end date");
      console.log(this.endDate);

      // var parts = this.startDate.split("-");
      // // Please pay attention to the month (parts[1]); JavaScript counts months from 0:
      // // January - 0, February - 1, etc.
      // var mydate = new Date(parts[0], parts[1] - 1, parts[2]);
      // console.log(mydate.toDateString());

      this.selectedDailyLog = this.dailyLogs.find(
        (x) =>
          x.employeeId === this.selectedEmplyoee.employeeId &&
          x.logDate === datumfull
      );

      console.log(this.selectedDailyLog);
      // switch (column) {
      //   case 5:
      //     if (this.selectedDailyLog.isLate) {
      //       this.isCommentCMVisible = false;
      //       this.isLateCMVisible = true;
      //     } else {
      //       this.isCommentCMVisible = true;
      //       this.isLateCMVisible = false;
      //     }
      //     break;
      //   default:
      //     this.isCommentCMVisible = true;
      //     this.isLateCMVisible = false;
      // }
      console.log(this.selectedEmplyoee.firstName);
      this.openContextMenu(params);
    },
    getData(departmentId, month, year) {
      ReportService.GetDailyLogsByDepartmentIdAndMonth(
        departmentId,
        month,
        year
      ).then((response) => {
        console.log("BBB");
        this.calculateData(response.data);
        this.applyAbsenceStatuses();
        this.resetUi();
        this.pushData();
        this.dailyLogs = response.data;
      });
    },

    calculateData(data) {
      // first add days array to employees
      this.employees.forEach((emp) => {
        emp.days = new Array(31).fill(0);
        emp.dayInconsistencies = new Array(31).fill(null);
        emp.total = 0;
      });
      data.forEach((dlog) => {
        // who I belong to?
        let emplyoee = this.employees.find(
          (e) => e.employeeId === dlog.employeeId
        );
        // what day is it?
        let day = new Date(dlog.logDate).getDate();
        let stat = getStatusCodeFromStatusId(
          dlog.statusId,
          dlog.statusIdOverride,
          this.$store.state.general.statuses
        );
        // don't show Sunday
        if (dlog.logDay === 0 && stat.startsWith("SN")) {
          stat = "  ";
        }
        if (dlog.statusId === 2) {
          emplyoee.total++;
        }

        // populate days
        emplyoee.days[day - 1] = stat;

        // Detect inconsistencies (same logic as InconsistencesView)
        let inconsistencyColor = this.getInconsistencyColor(dlog);
        if (inconsistencyColor) {
          emplyoee.dayInconsistencies[day - 1] = {
            color: inconsistencyColor,
            arrival: dlog.arrivalTimeGeneral,
            departure: dlog.departureTimeGeneral,
            totalTicks: dlog.totalWorkhoursThisDay,
            lateTicks: dlog.lateWorkhours,
          };
        }
      });
    },

    applyAbsenceStatuses() {
      // Apply absence status codes to future dates (where days[i] is still 0)
      if (!this.absenceStatuses || this.absenceStatuses.length === 0) {
        return;
      }

      // Status code mapping from statusId to code
      const statusCodeMap = {
        2: "GO", // Godišnji odmor
        3: "BO", // Bolovanje
        4: "SO", // Službeno na putu
        5: "PO", // Plaćeno odsustvo
        6: "PR", // Praznik
        7: "NO", // Neplaćeno odsustvo
        8: "SN", // Neradni dan
        9: "SR", // Slobodan radni dan
        10: "TB", // Trudničko / porodiljsko bolovanje
        12: "NP", // Nezaposlen
        14: "RK", // Rad od kuće
      };

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      this.absenceStatuses.forEach((absence) => {
        // Find the employee in our employees array
        const employee = this.employees.find(
          (e) => e.employeeId === absence.employeeId
        );

        if (!employee) {
          return; // Employee not in this department
        }

        // Parse absence start and end dates
        const absenceStart = new Date(absence.startDate);
        const absenceEnd = new Date(absence.endDate);
        absenceStart.setHours(0, 0, 0, 0);
        absenceEnd.setHours(0, 0, 0, 0);

        // Get status code for this absence
        const statusCode = statusCodeMap[absence.absenceStatus] || "??";

        // Iterate through each day in the absence range
        for (
          let d = new Date(absenceStart);
          d < absenceEnd;
          d.setDate(d.getDate() + 1)
        ) {
          // Check if this day is in the selected month/year
          if (
            d.getMonth() + 1 !== this.selectedMonth ||
            d.getFullYear() !== this.selectedYear
          ) {
            continue;
          }

          const dayOfMonth = d.getDate();
          const dayIndex = dayOfMonth - 1;

          // Only apply to future dates where the cell is still 0 (no log data)
          if (d >= today && employee.days[dayIndex] === 0) {
            // Add "P" prefix to indicate planned status
            employee.days[dayIndex] = "P" + statusCode;
            // Count GO (Godišnji odmor) for the total
            if (absence.absenceStatus === 2) {
              employee.total++;
            }
          }
        }
      });
    },

    pushData() {
      let ndx = 1;

      this.employees.forEach((emp) => {
        // console.log("emp")
        // console.log(emp)
        // add only those employees whose start date is lower then end of this month
        let startDate = new Date(emp.startDate);
        let endDate = emp.endDate
          ? new Date(emp.endDate)
          : new Date("3000-01-01");

        let startDatePass = false;
        let endDatePass = false;

        if (startDate < this.lastDay) {
          startDatePass = true;
        }

        if (endDate >= new Date(this.selectedYear, this.selectedMonth - 1, 1)) {
          endDatePass = true;
        }

        if (!startDatePass || !endDatePass) {
          return;
        }

        emp.correspondingRowId = ndx;

        let row = [
          ndx++,
          {
            value: emp.firstName + " " + emp.lastName,
          },
        ];

        // Build day cells (31 days) with inconsistency border indicators
        for (let i = 0; i < 31; i++) {
          let inconsistencyInfo = emp.dayInconsistencies
            ? emp.dayInconsistencies[i]
            : null;
          let tooltipText = this.getTooltipText(emp.days[i]);
          // Append inconsistency tooltip if present
          if (inconsistencyInfo) {
            let inconsistencyTip =
              this.getInconsistencyTooltip(inconsistencyInfo);
            tooltipText = tooltipText
              ? tooltipText + " | " + inconsistencyTip
              : inconsistencyTip;
          }
          row.push({
            value: this.formatCellValue(emp.days[i]),
            backgroundColor: this.calculateBackgroundColor(emp.days[i]),
            color: this.calculateFontColor(emp.days[i]),
            title: tooltipText,
            borderLeftColor: inconsistencyInfo ? inconsistencyInfo.color : null,
          });
        }

        row.push(this.formatCellValue(emp.total));
        this.params.data.push(row);
      });
    },

    calculateBackgroundColor(row) {
      // Future/planned status codes that should have stronger yellow background (P prefix = planned)
      const futureStatusCodes = [
        "PGO",
        "PBO",
        "PPO",
        "PPR",
        "PSN",
        "PSR",
        "PTB",
        "PNP",
        "PRK",
        "PSO",
        "PNO",
      ];

      // Check if it's an empty/zero cell (light yellow for future)
      if (row === 0 || row === "" || row === "0") {
        return "#FFFACD"; // Light yellow for empty future cells
      }
      // Check if it's a future/planned status code (stronger yellow)
      if (futureStatusCodes.includes(row)) {
        return "#FFD700"; // Gold/stronger yellow for planned absences
      }
      // Check for NO with padding (pink)
      if (row === "NO        ") {
        return "#f08bb7";
      }
      return "transparent";
    },

    calculateFontColor(row) {
      // Future/planned status codes that should have highlighted font color
      const futureStatusCodes = [
        "PGO",
        "PBO",
        "PPO",
        "PPR",
        "PSN",
        "PSR",
        "PTB",
        "PNP",
        "PRK",
        "PSO",
        "PNO",
      ];

      // Check if it's a future/planned status code
      if (futureStatusCodes.includes(row)) {
        return "#0066CC"; // Blue color for planned absences
      }
      return "#363636"; // Default dark color
    },

    getTooltipText(statusCode) {
      // Tooltip descriptions for planned status codes
      const tooltipMap = {
        PGO: "Planiran godišnji odmor",
        PBO: "Planirano bolovanje",
        PPO: "Planirano plaćeno odsustvo",
        PPR: "Planiran praznik",
        PSN: "Planiran neradni dan",
        PSR: "Planiran slobodan radni dan",
        PTB: "Planirano trudničko/porodiljsko bolovanje",
        PNP: "Planirano - nezaposlen",
        PRK: "Planiran rad od kuće",
        PSO: "Planirano službeno putovanje",
        PNO: "Planirano neplaćeno odsustvo",
      };
      return tooltipMap[statusCode] || "";
    },

    formatCellValue(dayValue) {
      // Mask 0, "0", "NN        " to empty string
      if (dayValue === 0 || dayValue === "0") {
        return "";
      }
      if (dayValue === "NN        ") {
        return "";
      }
      return dayValue;
    },

    getInconsistencyColor(dlog) {
      // Priority order (same as InconsistencesView):
      // 1. Overtime inconsistency (overtime == total workhours) - amber/warning
      if (
        (dlog.overtimeWorkhours === dlog.totalWorkhoursThisDay &&
          dlog.overtimeWorkhours > 0 &&
          dlog.statusId === 1) ||
        dlog.statusId == null
      ) {
        return "#EAB308";
      }
      // 2. Worked over 12h - cyan
      if (dlog.totalWorkhoursThisDay > 440000000000) {
        return "#06B6D4";
      }
      // 3. Worked under 6h (but more than 0) - blue
      if (
        dlog.totalWorkhoursThisDay < 216000000000 &&
        dlog.totalWorkhoursThisDay > 0
      ) {
        return "#3B82F6";
      }
      // 4. Extreme late - purple
      if (dlog.lateWorkhours > 18000000000) {
        return "#8B54E4";
      }
      // 5. Too long outside event - green
      if (dlog.outsideEvent && dlog.outsideEvent.length > 0) {
        for (let oe of dlog.outsideEvent) {
          if (
            oe.isLogicallyClosed === true &&
            oe.duration > 144000000000 &&
            oe.leavingReasonId == null &&
            oe.routeName === "" &&
            new Date(oe.arrivalTime) >
              new Date(oe.arrivalTime.split("T")[0] + "T18:00:00")
          ) {
            return "#3ba272";
          }
        }
      }
      return null;
    },

    ticksToHoursMinutes(ticks) {
      if (!ticks || ticks <= 0) return "";
      let totalMinutes = Math.floor(ticks / 600000000);
      let hours = Math.floor(totalMinutes / 60);
      let minutes = totalMinutes % 60;
      return hours + "h " + String(minutes).padStart(2, "0") + "m";
    },

    extractTime(datetimeStr) {
      if (!datetimeStr) return "?";
      let parts = datetimeStr.split("T");
      if (parts.length < 2) return "?";
      // Return HH:MM only
      return parts[1].substring(0, 5);
    },

    getInconsistencyTooltip(info) {
      const labelMap = {
        "#EAB308": "Prekovremeni = ukupni",
        "#06B6D4": "Preko 12h",
        "#3B82F6": "Manje od 6h",
        "#8B54E4": "Ekstr. kašnjenje",
        "#3ba272": "Predug izlazak",
      };
      let label = labelMap[info.color] || "";
      let arrival = this.extractTime(info.arrival);
      let departure = this.extractTime(info.departure);
      let total = this.ticksToHoursMinutes(info.totalTicks);
      let timeStr = arrival + "-" + departure;
      if (total) {
        timeStr += " (" + total + ")";
      }
      return label + ": " + timeStr;
    },

    arrangeData(inputDailyLogs) {
      console.log(inputDailyLogs);
      // console.log("PAPAGAJ");
      // // // reset ui
      // // this.resetUi(false);

      // // find logs belonging to my department
      // // let myDailyLogs = getDailyLogsFromDepartmentId(
      // //   this.inputDailyLogs,
      // //   this.department.id
      // // );
      // let myDailyLogs = inputDailyLogs;

      // console.log(inputDailyLogs);

      // let ndx = 1;
      // // console.log("my daily logs " + this.department.name);
      // // console.log(myDailyLogs);

      // // extract my department from department data
      // let myDepartment = this.department;
      // console.log(myDepartment);
      // console.log(this.employees);

      // // console.log("my departmentData");
      // // console.log(myDepartment);
      // // this.employees = myDepartment.employee;

      // // console.log("my employees");
      // // console.log(this.employees);

      // // populate table
      // myDailyLogs.forEach((element) => {
      //   // console.log("element");
      //   // console.log(element);
      //   this.dailyLogs.push(element);
      //   let selectedEmp = this.employees.find(
      //     (x) => x.employeeId === element.employeeId
      //   );
      //   let index = this.employees.indexOf(selectedEmp);
      //   // console.log(index);
      //   this.employees[index].correspondingRowId = ndx;
      //   // console.log(this.employees[index]);
      //   // console.log("AAA");

      // });
    },
  },
};
</script>

<style scoped>
.ex1 {
  margin-top: 30px;
}
.cmitem {
  /* margin: 20px;
  border-color: blue;
  border-width: 2px; */
  width: 150px;
  border: none;
  background-color: inherit;
  padding: 14px 28px;
  font-size: 12px;
  cursor: pointer;
  display: inline-block;
}

/* .base-demo {
  width: 2700px;
} */

.cmitem:hover {
  background: #c3ffeb;
}

.base-demo {
  width: 1550px;
  white-space: nowrap;
}

.small {
  font-size: 10px;
}

.base-demo >>> .v-table-row.is-header {
  /* background: red !important; */
  /* border-top: 1px solid red !important; */
  /* border-right: 1px solid red !important; */
  border-bottom: 1px solid red !important;
}

.base-demo >>> .table-cell {
  /* border-left: 1px solid red !important; */
  padding: 1px !important;
  /* flex: 0 0 30px !important; */
}

.base-demo >>> .table-cell-content {
  /* border-left: 1px solid red !important; */
  /* margin: 0px -10px 0px -10px !important; */
  padding: 0px !important;
  /* flex: 0 0 0 0px !important; */
}

.cell--slot-1 {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
}

/* Triangle indicator for inconsistencies (upper-right corner) */
.cell-inconsistency-triangle {
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  border-top: 8px solid transparent; /* color set dynamically via :style */
  border-left: 8px solid transparent;
  pointer-events: none;
}
</style>
